import "./style.css"
import React from "react"

export default function ListViewGallery({name,name2,image,product,date}) {
    return(
        <div className="list_view_gallery_ind">
            <div className="image_section_lvgi">
                <img src={image} alt="" />
                <div className="image_name_lvgi">
                    <h2>{name}</h2>
                    <p>{name2}</p>
                </div>
            </div>
            <div className="author_detail_lvgi">
                <p>Maaz Naeem</p>
            </div>
            <div className="uploaded_to_lvgi">
                <h3>{product}</h3>
                <p>Detach</p>
            </div>
            <div className="date_lvgi">
                <p>{date}</p>
            </div>
        </div>
    )
}